const base = "backend";
// const base = ''
const _ = url => base.concat(url);
// const mockBase = '/mock'; //mock前缀
// const mockBase = ''
export const rootUrl = {
  // getUserinfo: _('/getUserinfo'),
  // getPermission: _('/getPermission'),
  // logout: _('/logout'),
  getTopNewsFromModule: _("/news/getTopNewsFromModule"),

  getToken: _("/upload/tokenize.do"),

  getNews: _("/news/getNews"),
  loginURL: _("/login/login"),
  logoutURL: _("/login/logout"),
  sendEamilCode: _("/login/sendCode"),
  getValidareCode: _("/login/getValidareCode"),
  getRaskey: _("/login/encryptionBeforre"),
  checkEmailCode: _("/login/checkEmailCode"),
  updatePassWord: _("/login/updatePassWord"),
  compareValidareCode: _("/login/compareValidareCode"),
  getloginEmail: _("/login/getloginEmail"),
  checkLogin: _("/login/checkLogin"),
  getStoreUrl: _("/login/getStoreUrl"),

  webMenu: _("/setting/webMenu"),
  getConfig: _("/setting/getConfig"),

  getCode: _("/register/getCode"),
  registerUser: _("/register/registerUser"),
  testinsert: _("/register/insertUser"),
  sendSMS: _("/register/sendSMS"),
  saveDeveloper: _("/register/saveDeveloper"),
  getprovince: _("/register/getAllProvice"),
  getCityByprovince: _("/register/getCityByProviceId"),
  getdistrictByCiyt: _("/register/getDistrictByCityId"),

  developerModify: _("/developer/developerModify"),
  getDeveloperByLoginName: _("/developer/getDeveloperByLoginName"),
  getUserInfo: _("/developer/getUserInfo"),
  getEmailCode: _("/developer/getEmailCode"),
  validateCodeEmail: _("/developer/validateCodeEmail"),
  getEmailCodeNew: _("/developer/getEmailCodeNew"),
  sendSMSNew: _("/developer/sendSMSNew"),
  validateCodePhone: _("/developer/validateCodePhone"),
  updatDeveloporPass: _("/developer/updatDeveloporPass"),

  saveDeveloperApp: _("/developerApp/saveDeveloperApp"),
  getDevelopAppById: _("/developerApp/getDevelopAppById"),
  completeDevelopApp: _("/developerApp/completeDevelopApp"),
  getUserType: _("/developerApp/getUserType"),
  getAppPhase: _("/developerApp/getAppPhase"),
  getAppLevel: _("/developerApp/getAppLevel"),
  deleteApp: _("/developerApp/deleteApp"),
  getAppClassification: _("/developerApp/getAppClassification"),

  //获取开发者应用列表
  getAppList: _("/developerApp/getAppList"),
  //更新应用详情，修改和应用上架申请都掉用这个接口
  updateAppDetail: _("/developerApp/updateDevelopApp"),

  //权限验证
  checkAuth: _("/auth/checkAuth"),

  //获取授权列表集合
  getAuthList: _("/developerApp/getAppAuthList"),
  //添加授权
  addAppAuth: _("/developerApp/addAppAuth"),
  //修改授权时间，(授权管理)
  batchUpdateEndTime: _("/developerApp/batchUpdateEndTime"),
  //取消授权
  cancelAppAuth: _("/developerApp/cancelAppAuth"),
  //获取未授权学校列表
  getSchoolList: _("/developerApp/getOrgList"),

  //查询省、市、区/县
  getProvinces: _("/developerApp/getProvinceList"),
  getCityList: _("/developerApp/getCityList"),
  getDistrictList: _("/developerApp/getDistrictList"),

  getCategoryDetail: _("/developerApp/getAppDetail"),
  /* 通过条件筛选我的API申请列表 */
  getApiApplyRecordList: _("/ApiManage/getApiApplyRecordList"),
  /* 获取API分类列表 */
  queryGroupList: _("/api/queryGroupList"),
  /* 获取待申请api列表 */
  queryApiList: _("/api/queryApiList"),
  /* 添加我的API申请记录 */
  addMyApiRecord: _("/ApiManage/addApiRecord"),
  /* 根据记录id重新/取消申请 */
  changeRecordById: _("/ApiManage/changeRecordById"),
  /* 获取api详情信息 */
  getApiDebuggInfo: _("/api/queryApiDebug"),
  /* 调试api接口 */
  debugerApiResult: _("/api/debugApi"),
  /* 生成SDK */
  generateSDK: _("/api/generateSDK"),
  /* 获取某应用下的敏感分组申请信息 */
  getAppSensitiveDataList: _("/sensitiveData/getApiGroupList"),
  /* 获取分组下所有敏感字段 */
  getGroupSensitiveParamList: _("/sensitiveData/getGroupSensitiveParamList"),
  /* 申请/取消申请敏感数据 */
  changeSensitive: _("/sensitiveData/changeSensitiveParam"),
  /* 获取api网关UrL */
  getApiUrl: _("/api/getApiHost"),
  /* 获取平台省市区信息 */
  getPlatFormInfo: _("/developerApp/getPlatFormInfo"),

  // 文档中心
  /* 查询所有分组 */
  getGroupList: _("/contentManage/getGroupList"),
  /* 根据分组id查询所有接口 */
  getApiListByGroup: _("/contentManage/getApiListByGroup"),
  /* 查询接口详情 */
  getApiDetail: _("/contentManage/getApiDetail"),
  /* 查询接口（出参）详情 */
  getInterfaceResultParamListByApiId: _(
    "/contentManage/getInterfaceResultParamListByApiId"
  ),
  /* 查询接口（入参）详情 */
  getInterParamListByApiId: _("/contentManage/getInterParamListByApiId"),
  /* api下钻接口 */
  getPropertyByEntityId: _("/contentManage/getPropertyByEntityId"),
  /* 获取应用概括信息 */
  getAppApiConfig: _("/developerApp/getAppApiConfig"),
  /* 搜索API接口 */
  getApiByName: _("/contentManage/getApiByName"),
  /* API接入类别分组接口 */
  getApiGroupClassifyAndExternalList: _(
    "/contentManage/getApiGroupClassifyAndExternalList"
  ),
  /* 集团校 */
  getGroupSchoolList: _("/developerApp/getGroupSchoolList"),
  /* 签署协议时间 */
  saveUserProtocol: _("/register/saveUserProtocol"),
  /* SSO */
  getSSOConfig: _("/login/getSSOConfig"),
  // 个人中心-问题反馈
  /* 新增在线反馈 */
  saveFeedback: _("/userFeedback/saveFeedback"),
  /* 获取在线反馈列表 */
  searchForManager: _("/userFeedback/searchForManager"),
  /* 获取用户反馈列表 */
  searchUserFeedbackForDeveloper: _(
    "/userFeedback/searchUserFeedbackForDeveloper"
  ),
  /* 获取系统消息 */
  getPageMessage: _("/message/getPageMessage"),
  /* 删除消息 */
  delMessage: _("/message/delMessage"),
  // 获取文档中心，文档模版下载下的所有文档信息
  qualificationsDoc: _("/contentManage/qualificationsDoc"),

  //运维文档页面接口

  // 获取运维文档
  getMaintenanceDocById: _("/developerApp/getMaintenanceDocById"),
  // 运维文档上传
  maintenanceDocUpload: _("/developerApp/maintenanceDocUpload"),
  deleteMaintenanceDocById: _("/developerApp/deleteMaintenanceDocById"),

  /* 获取系统应用申请授权的列表 */
  getApplyAuthList: _("/developerSysApp/getSysAppAuthList"),
  /* 发起授权申请 */
  addSysAppAuth: _("/developerSysApp/addSysAppAuth"),
  /* 批量管理系统应用的截至时间 */
  batchUpdateSysAppEndTime: _("/developerSysApp/batchUpdateSysAppEndTime"),
  /* 取消授权 */
  cancelSysAppAuth: _("/developerSysApp/cancelSysAppAuth"),
  /*  */
  getExchangeMenuEnable: _('/login/getExchangeMenuEnable'),
  changeSwfToHtml: _('/developerApp/changeSwfToHtml')
};

//返回代码
export const ReturnCode = {
  success: "1"
};
// 统一提示语
export const tipMessage = {
  error: "系统错误请重试",
  warning: "警告哦，这是一条警告消息"
};

//cystorage文件服务配置信息
export const CystorageInfo = {
  appName: "", // * AppName，必需
  server: "", // * 文件服务地址，必需
  tokenUrl: rootUrl.getToken, //获取cystorage的token请求地址
  debug: true // 关闭或打开日志开关，不写默认为打开
};

export const reviewStateMap = {
  appOnline: {
    name: "online",
    status: "4"
  },
  appUnOnline: {
    name: "unline",
    status: "10"
  },
  appOutOnline: {
    name: "offline",
    status: "6"
  }
};

// 定义一些常量
export const PublicData = {
  appLevelList: [
    {
      id: "1",
      name: "省级"
    },
    {
      id: "2",
      name: "市级"
    },
    {
      id: "3",
      name: "区县级"
    },
    {
      id: "3",
      name: "校级"
    }
  ],
  //电话号码
  phoneRegular: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
  //邮箱
  emailReg: /^[0-9a-z]([._]?[0-9a-z])+@([0-9a-z][-\w]*[0-9a-z]\.)+[a-z]{2,9}$/,
  //密码
  passWorldRegular: /^(?!([0-9]+|[a-z]+|[A-Z]+|[!@￥#*_]+|[0-9a-z]+|[0-9A-Z]+|[0-9@￥!#*_]+|[a-zA-Z]+|[a-z!@￥#*_]+|[A-Z!#@￥*_]+)$)^[a-zA-Z0-9!#@￥*_]{8,16}$/,
  //社会信用码
  creditCodeRegular: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
  // 座机号码
  specialTelRegular: /(^0\d{2}-\d{8}$)|(^0\d{3}-\d{7}$)/,
  //身份证
  idNumberRegular: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/,
  // 适用系统
  appSystemList: [
    {
      id: "61",
      name: "Windows"
    },
    {
      id: "62",
      name: "Android"
    },
    {
      id: "63",
      name: "iOS"
    },
    {
      id: "64",
      name: "Mac OS"
    }
  ],
  // 适用终端
  appTerminalList: [
    {
      id: "31",
      name: "网页端"
    },
    {
      id: "32",
      name: "手机端"
    },
    {
      id: "33",
      name: "PC端"
    } /* ,
    {
      id:"34",
      name:"智屏"
    },
    {
      id:"35",
      name:"班牌"
    } */
  ]
};

//返回代码
export const AppState = {
  initialize: "10"
};

export const PAGE_SIZE = 8;
export const ERR_OK = 1;



// WEBPACK FOOTER //
// ./src/common/js/config.js